import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/styles';
import { typography, elevation } from '@skyslope/mache';

const StyledTooltip = withStyles({
  tooltip: {
    ...(typography.body1 as any),
    backgroundColor: 'white',
    padding: 16,
    boxShadow: elevation.normal[12],
    position: 'relative',
    marginTop: 8,
  },
  arrow: {
    color: 'white',
  },
})(Tooltip);

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default StyledTooltip;
